(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.header.dataset.adaptiveReady) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-ab-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mova-ab-example')) {
    class MovaABExample extends HTMLElement {
      static active = null;
      static context = null;

      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.playButton = this.querySelector('[data-play]');
        this.progress = this.querySelector('[data-progress]');
        this.clock = this.querySelector('[data-time]');
        this.status = this.querySelector('[data-status]');
        this.mode = this.dataset.mode || 'before';
        this.offset = 0;
        this.duration = 0;
        this.generation = (this.generation || 0) + 1;
        this.state = 'idle';
        this.sources = [];
        this.gains = [];
        this.urls = [this.dataset.before, this.dataset.after];
        this.waveMessage = this.querySelector('[data-wave-message]');
        this.waveControl = this.querySelector('.mova-ab__wave');
        this.waveControl.addEventListener('click', event => {
          const rect = this.waveControl.getBoundingClientRect();
          const fraction = (event.clientX - rect.left - 16) / Math.max(1, rect.width - 32);
          this.seek(fraction * this.duration, true);
        }, {signal:this.abort.signal});
        this.waveControl.addEventListener('keydown', event => {
          const moves = {ArrowLeft:-.5,ArrowDown:-.5,ArrowRight:.5,ArrowUp:.5,PageDown:-this.duration*.1,PageUp:this.duration*.1};
          if (event.key === 'Home' || event.key === 'End' || event.key in moves) {
            event.preventDefault();
            this.seek(event.key === 'Home' ? 0 : event.key === 'End' ? this.duration : this.position() + moves[event.key]);
          }
        }, {signal:this.abort.signal});
        this.waveObserver = new ResizeObserver(() => this.drawWaveforms(this.position()));
        this.waveObserver.observe(this.querySelector('.mova-ab__wave'));
        const supported = !!(window.AudioContext || window.webkitAudioContext);
        this.playButton.disabled = !supported || this.urls.some(url => !url);
        if (!supported) this.status.textContent = this.labels.unsupported;
        if (!this.hidden) this.prepareWaveform();
        this.querySelectorAll('[data-mode-button]').forEach(button => button.addEventListener('click', () => this.setMode(button.dataset.modeButton), { signal: this.abort.signal }));
        this.playButton.addEventListener('click', () => {
          if (this.state === 'playing' || this.state === 'loading') this.pause();
          else this.start();
        }, { signal: this.abort.signal });
        window.addEventListener('pagehide', () => this.pause(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pause(); }, { signal: this.abort.signal });
      }

      setMode(mode) {
        this.mode = mode;
        this.dataset.mode = mode;
        this.querySelectorAll('[data-mode-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modeButton === mode)));
        this.querySelectorAll('[data-visual]').forEach(visual => { visual.hidden = visual.dataset.visual !== mode; });
        const now = MovaABExample.context?.currentTime || 0;
        this.gains.forEach((gain, index) => {
          gain.gain.cancelScheduledValues(now);
          gain.gain.setTargetAtTime(index === (mode === 'before' ? 0 : 1) ? 1 : 0, now, 0.018);
        });
        if (this.state === 'playing') this.status.textContent = this.labels[mode];
        this.drawWaveforms(this.position());
      }

      setState(state, message) {
        this.state = state;
        this.dataset.state = state;
        this.playButton.setAttribute('aria-pressed', String(state === 'playing' || state === 'loading'));
        this.playButton.setAttribute('aria-busy', String(state === 'loading'));
        this.querySelector('[data-play-icon]').textContent = state === 'playing' ? 'Ⅱ' : state === 'loading' ? '×' : '▶';
        this.querySelector('[data-play-label]').textContent = this.labels[state === 'playing' ? 'pause' : state === 'loading' ? 'cancel' : 'play'];
        if (message) this.status.textContent = message;
      }

      async start() {
        if (this.playButton.disabled || this.hidden) return;
        MovaABExample.active?.pause();
        MovaABExample.active = this;
        const generation = ++this.generation;
        this.setState('loading', this.labels.loading);
        try {
          const AudioContextClass = window.AudioContext || window.webkitAudioContext;
          if (!MovaABExample.context || MovaABExample.context.state === 'closed') MovaABExample.context = new AudioContextClass();
          const context = MovaABExample.context;
          await context.resume();
          if (!this.isCurrent(generation)) return;
          await this.ensureBuffers();
          if (!this.isCurrent(generation)) return;
          const durations = this.buffers.map(buffer => buffer.duration);
          this.duration = Math.min(...durations);
          if (!Number.isFinite(this.duration) || this.duration <= 0) throw new Error('audio-unavailable');
          if (Math.abs(durations[0] - durations[1]) > 0.1) throw new Error('duration-mismatch');
          if (this.offset >= this.duration - 0.01) this.offset = 0;
          this.startTime = context.currentTime + 0.025;
          this.startOffset = this.offset;
          this.buffers.forEach((buffer, index) => {
            const source = context.createBufferSource();
            const gain = context.createGain();
            source.buffer = buffer;
            gain.gain.value = index === (this.mode === 'before' ? 0 : 1) ? 1 : 0;
            source.connect(gain).connect(context.destination);
            this.sources.push(source);
            this.gains.push(gain);
            source.start(this.startTime, this.offset, this.duration - this.offset);
          });
          this.sources[0].onended = () => { if (this.isCurrent(generation) && this.state === 'playing') this.finish(); };
          this.setState('playing', this.labels[this.mode]);
          this.tick();
        } catch (error) {
          if (!this.isCurrent(generation)) return;
          this.stopSources();
          this.loadAbort?.abort();
          this.buffers = null;
          MovaABExample.active = null;
          this.setState('error', this.labels[error.message === 'duration-mismatch' ? 'mismatch' : 'error']);
        }
      }

      async ensureBuffers() {
        if (this.buffers) return this.buffers;
        if (this.bufferPromise) return this.bufferPromise;
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass || this.urls.some(url => !url)) throw new Error('audio-unavailable');
        if (!MovaABExample.context || MovaABExample.context.state === 'closed') MovaABExample.context = new AudioContextClass();
        const context = MovaABExample.context;
        this.loadAbort = new AbortController();
        const loadAbort = this.loadAbort;
        this.bufferPromise = Promise.all(this.urls.map(async url => {
          const response = await fetch(url, {signal:loadAbort.signal,credentials:'omit'});
          if (!response.ok) throw new Error('audio-unavailable');
          return context.decodeAudioData(await response.arrayBuffer());
        })).then(buffers => {
          if (!this.isConnected || loadAbort.signal.aborted) throw new Error('audio-unavailable');
          if (Math.abs(buffers[0].duration - buffers[1].duration) > .1) throw new Error('duration-mismatch');
          this.buffers = buffers;
          this.duration = Math.min(...buffers.map(b => b.duration));
          this.peaks = buffers.map(buffer => {
            const peaks = new Array(180).fill(0);
            for (let channel=0;channel<buffer.numberOfChannels;channel++) {
              const data=buffer.getChannelData(channel);
              for(let i=0;i<peaks.length;i++) {
                const end=Math.min(data.length,Math.floor((i+1)*data.length/peaks.length));
                for(let j=Math.floor(i*data.length/peaks.length);j<end;j++) peaks[i]=Math.max(peaks[i],Math.abs(data[j]));
              }
            }
            return peaks;
          });
          this.peakMax=Math.max(.001,...this.peaks.flat());
          this.waveMessage.hidden=true;
          this.renderTime(this.position());
          return buffers;
        }).finally(() => {this.bufferPromise=null;});
        return this.bufferPromise;
      }
      async prepareWaveform() {
        try { await this.ensureBuffers(); }
        catch (_) { if (this.isConnected) this.waveMessage.textContent=this.labels.error; }
      }
      drawWaveforms(position=0) {
        if (!this.peaks || this.hidden) return;
        const style=getComputedStyle(this.closest('.mova-ab'));
        const color=style.getPropertyValue('--ab-accent').trim();
        const fraction=this.duration ? position/this.duration : 0;
        this.querySelectorAll('[data-wave]').forEach((canvas,index)=>{
          const width=canvas.clientWidth,height=canvas.clientHeight;
          if (!width || !height) return;
          const scale=Math.min(window.devicePixelRatio||1,2);
          if(canvas.width!==Math.round(width*scale)||canvas.height!==Math.round(height*scale)) {
            canvas.width=Math.round(width*scale);canvas.height=Math.round(height*scale);
          }
          const ctx=canvas.getContext('2d');if(!ctx)return;
          ctx.setTransform(scale,0,0,scale,0,0);ctx.clearRect(0,0,width,height);
          const inset=16,area=width-inset*2,step=area/this.peaks[index].length;
          this.peaks[index].forEach((peak,i)=>{
            const bar=Math.max(2,peak/this.peakMax*(height-40));
            ctx.globalAlpha=i/this.peaks[index].length<=fraction ? 1:.6;
            ctx.fillStyle=color;ctx.fillRect(inset+i*step,(height-bar)/2,Math.max(1,step*.65),bar);
          });
          if(fraction>0){ctx.globalAlpha=.85;ctx.fillStyle=style.getPropertyValue('--ab-text').trim();ctx.fillRect(inset+fraction*area,12,1,height-24);}
          ctx.globalAlpha=1;
        });
      }

      isCurrent(generation) {
        return this.isConnected && this.generation === generation && MovaABExample.active === this;
      }

      seek(position, play = false) {
        if (!this.duration || !Number.isFinite(position) || this.hidden) return;
        const resume = play || this.state === 'playing' || this.state === 'loading';
        this.pause();
        this.offset = Math.max(0, Math.min(this.duration, position));
        this.setState(this.offset === this.duration ? 'ended' : 'paused', this.offset === this.duration ? this.labels.ended : this.labels.paused);
        this.renderTime(this.offset);
        if (resume && this.offset < this.duration) this.start();
      }

      position() {
        if (this.state !== 'playing') return this.offset;
        return Math.min(this.duration, this.startOffset + Math.max(0, MovaABExample.context.currentTime - this.startTime));
      }

      renderTime(position) {
        const format = time => `${Math.floor(time / 60)}:${String(Math.floor(time % 60)).padStart(2, '0')}`;
        this.clock.textContent = `${format(position)} / ${format(this.duration)}`;
        this.progress.max = this.duration || 1;
        this.progress.value = position;
        this.waveControl.setAttribute('aria-valuemax', String(this.duration));
        this.waveControl.setAttribute('aria-valuenow', String(Math.round(position * 100) / 100));
        this.waveControl.setAttribute('aria-valuetext', this.clock.textContent);
        this.waveControl.setAttribute('aria-disabled', String(!this.duration));
        this.drawWaveforms(position);
      }

      tick() {
        if (this.state !== 'playing') return;
        this.renderTime(this.position());
        this.frame = requestAnimationFrame(() => this.tick());
      }

      stopSources() {
        cancelAnimationFrame(this.frame);
        this.sources.forEach(source => {
          source.onended = null;
          try { source.stop(); } catch (_) { }
          source.disconnect();
        });
        this.gains.forEach(gain => gain.disconnect());
        this.sources = [];
        this.gains = [];
      }

      pause() {
        if (!this.initialized || !['playing', 'loading'].includes(this.state)) return;
        this.offset = this.position();
        ++this.generation;
        this.stopSources();
        if (MovaABExample.active === this) MovaABExample.active = null;
        this.setState('paused', this.labels.paused);
        this.renderTime(this.offset);
      }

      reset() {
        if (!this.initialized) return;
        this.pause();
        this.offset = 0;
        this.setMode('before');
        this.setState('idle', this.labels.ready);
        this.renderTime(0);
      }

      finish() {
        this.stopSources();
        this.offset = 0;
        if (MovaABExample.active === this) MovaABExample.active = null;
        this.setState('ended', this.labels.ended);
        this.renderTime(this.duration);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.pause();
        this.loadAbort?.abort();
        this.abort?.abort();
        this.waveObserver?.disconnect();
        this.buffers = null;
        this.peaks = null;
        this.initialized = false;
      }
    }
    customElements.define('mova-ab-example', MovaABExample);
  }

  if (!customElements.get('mova-ab-carousel')) {
    class MovaABCarousel extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => {
          this.abort?.abort();
          this.abort = new AbortController();
          this.cards = [...this.querySelectorAll('mova-ab-example')];
          this.index = 0;
          this.querySelectorAll('[data-demo-index]').forEach(button => button.addEventListener('click', () => {const index=Number(button.dataset.demoIndex);this.select(index);}, {signal:this.abort.signal}));
          document.addEventListener('shopify:block:select', event => {
            const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
            if (index >= 0) this.select(index);
          }, {signal:this.abort.signal});
          this.select(0);
        });
      }
      select(index) {
        if (!this.cards.length) {
          this.querySelector('[data-count]').textContent = '0 / 0';
          this.querySelectorAll('[data-demo-index]').forEach(b => { b.disabled = true; });
          return;
        }
        this.index = (index + this.cards.length) % this.cards.length;
        this.cards.forEach((card, i) => {
          card.pause?.(); card.hidden = i !== this.index;
          if (!card.hidden && card.initialized) {card.reset();card.prepareWaveform();}
        });
        this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.cards.length}`;
        this.querySelectorAll('[data-demo-index]').forEach((b,i) => {b.disabled=false;b.setAttribute('aria-pressed',String(i===this.index));});
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame); this.abort?.abort(); this.cards?.forEach(c => c.pause?.()); }
    }
    customElements.define('mova-ab-carousel', MovaABCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mova-editorial')) {
  customElements.define('mova-editorial', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.edge?.remove();
      const edgeTemplate=this.querySelector('[data-edge-effect]');
      if(edgeTemplate && !matchMedia('(max-width: 899px)').matches){
        this.edge=edgeTemplate.content.firstElementChild.cloneNode(true);
        document.getElementById('MainContent')?.append(this.edge);
      }
      this.effectAbort?.abort();
      this.effectAbort=new AbortController();
      const film=this.querySelector('.me__hero-backdrop video');
      const toggle=this.querySelector('[data-film-toggle]');
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.tiltCleanup?.();
      const finePointer=window.matchMedia('(hover: hover) and (pointer: fine)');
      const tiltImages=[...this.querySelectorAll('.me__detail-image')];
      const strength=Math.min(5,Math.max(0,Number(this.dataset.tiltStrength)||3));
      let tiltFrame=0;
      const clearTilt=()=>{
        if (!tiltFrame && !this.querySelector('[data-tilt-active]')) return;
        cancelAnimationFrame(tiltFrame);tiltFrame=0;
        tiltImages.forEach(image=>{
          image.removeAttribute('data-tilt-active');
          image.style.removeProperty('--me-tilt-x');
          image.style.removeProperty('--me-tilt-y');
        });
      };
      this.tiltCleanup=clearTilt;
      if(this.dataset.tilt==='true'){
        tiltImages.forEach(image=>{
          image.addEventListener('pointermove',event=>{
            if(event.pointerType!=='mouse' || reduced.matches || !finePointer.matches)return;
            const rect=image.getBoundingClientRect();
            const x=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
            const y=Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1));
            cancelAnimationFrame(tiltFrame);
            tiltFrame=requestAnimationFrame(()=>{
              image.setAttribute('data-tilt-active','');
              image.style.setProperty('--me-tilt-x',`${-y*strength}deg`);
              image.style.setProperty('--me-tilt-y',`${x*strength}deg`);
              tiltFrame=0;
            });
          },{passive:true,signal:this.effectAbort.signal});
          image.addEventListener('pointerleave',clearTilt,{signal:this.effectAbort.signal});
          image.addEventListener('pointercancel',clearTilt,{signal:this.effectAbort.signal});
        });
        reduced.addEventListener('change',clearTilt,{signal:this.effectAbort.signal});
        finePointer.addEventListener('change',clearTilt,{signal:this.effectAbort.signal});
        window.addEventListener('blur',clearTilt,{signal:this.effectAbort.signal});
        window.addEventListener('scroll',clearTilt,{passive:true,signal:this.effectAbort.signal});
      }
      const updateMotion=()=>{
        this.dataset.ambientPaused=String(document.hidden || !this.editorialVisible);
        if(!film)return;
        const pause=document.hidden || !this.heroVisible || reduced.matches || this.filmUserPaused;
        if(pause)film.pause();else film.play().catch(()=>{});
      };
      if(film){
        film.muted=true;
        const showState=()=>{toggle.hidden=reduced.matches;toggle.setAttribute('aria-pressed',String(film.paused));toggle.querySelector('span').textContent=film.paused?'▶':'Ⅱ';};
        toggle.addEventListener('click',()=>{this.filmUserPaused=!film.paused;updateMotion();},{signal:this.effectAbort.signal});
        film.addEventListener('play',showState,{signal:this.effectAbort.signal});
        film.addEventListener('pause',showState,{signal:this.effectAbort.signal});
        reduced.addEventListener('change',()=>{updateMotion();showState();},{signal:this.effectAbort.signal});
        this.heroObserver?.disconnect();
        this.heroObserver=new IntersectionObserver(entries=>{this.heroVisible=entries[0].isIntersecting;updateMotion();},{threshold:.05});
        this.heroObserver.observe(this.querySelector('.me__hero'));
        showState();
      }
      this.effectObserver?.disconnect();
      this.effectObserver=new IntersectionObserver(entries=>{
        this.editorialVisible=entries[0].isIntersecting;
        updateMotion();
      });
      this.effectObserver.observe(this);
      document.addEventListener('visibilitychange',updateMotion,{signal:this.effectAbort.signal});
      const header = document.querySelector('.section-header');
      if (!header || !window.ResizeObserver) return;
      this.observer = new ResizeObserver(() => {
        const sticky = ['sticky', 'fixed'].includes(getComputedStyle(header).position);
        this.style.setProperty('--me-header', `${sticky ? header.getBoundingClientRect().height : 0}px`);
      });
      this.observer.observe(header);
    }
    disconnectedCallback() { this.tiltCleanup?.(); this.observer?.disconnect(); this.effectObserver?.disconnect(); this.effectAbort?.abort(); this.edge?.remove(); this.heroObserver?.disconnect(); this.querySelector(".me__hero-backdrop video")?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mova-pro-launch')) {
  customElements.define('mova-pro-launch', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.launchAt);
      if (!Number.isFinite(this.deadline)) return;
      this.update();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const expired = remaining === 0;
      this.querySelector('.mp__countdown').hidden = expired;
      this.querySelector('.mp__countdown-label').hidden = expired;
      this.querySelector('[data-early-access]').hidden = expired;
      this.querySelector('.mp__launch-ended').hidden = !expired;
      if (expired) { clearInterval(this.interval); return; }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-lite-signup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const decorate = () => {
    const host = document.querySelector('.mls__form');
    const email = host?.querySelector('input[name="email_address"]');
    if (!email) return false;
    email.type = 'email';
    email.autocomplete = 'email';
    email.placeholder = host.dataset.emailLabel;
    email.setAttribute('aria-label', host.dataset.emailLabel);
    return true;
  };
  if (decorate()) return;
  const observer = new MutationObserver(() => { if (decorate()) observer.disconnect(); });
  observer.observe(document.body, {childList:true,subtree:true});
  setTimeout(() => observer.disconnect(),120000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mova-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mova-showcase')) {
  customElements.define('mova-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const stage = this.querySelector('.mova__stage');
      const range = this.querySelector('input[type="range"]');
      const pause = this.querySelector('.mova__pause');
      const views = [...this.querySelectorAll('[data-view]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const fine = matchMedia('(hover: hover) and (pointer: fine)');
      this.paused = reduced.matches || this.dataset.auto === 'false';
      this.manual = false;
      this.progress = 0;
      this.querySelector('.mova__controls').hidden = false;
      const showProgress = value => {
        value = Math.max(0, Math.min(1, value));
        if (Math.abs(value - this.progress) < .008) return;
        this.progress = value;
        this.style.setProperty('--spread', value.toFixed(3));
        range.value = Math.round(value * 100);
        views.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.view) === (value >= .5 ? 1 : 0))));
      };
      const setPause = () => {
        this.classList.toggle('is-paused', this.paused);
        pause.setAttribute('aria-pressed', String(this.paused));
        pause.setAttribute('aria-label', this.paused ? pause.dataset.resume : pause.dataset.pause);
        pause.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
      };
      setPause();
      pause.addEventListener('click', () => { this.paused = !this.paused; setPause(); }, {signal});
      reduced.addEventListener('change', () => { this.paused = reduced.matches; setPause(); }, {signal});
      views.forEach(button => button.addEventListener('click', () => { this.manual = true; showProgress(Number(button.dataset.view)); }, {signal}));
      range.addEventListener('input', () => { this.manual = true; showProgress(Number(range.value) / 100); }, {signal});
      const scroll = () => {
        if (!this.visible || this.manual || this.paused || reduced.matches || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const box = stage.getBoundingClientRect();
          showProgress((innerHeight * .37 - box.top) / (box.height * .75));
        });
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.classList.toggle('is-visible', this.visible && !document.hidden);
        if (this.visible) scroll();
      }, {threshold:0});
      this.observer.observe(stage);
      window.addEventListener('scroll', scroll, {passive:true,signal});
      window.addEventListener('resize', scroll, {passive:true,signal});
      document.addEventListener('visibilitychange', () => this.classList.toggle('is-visible', this.visible && !document.hidden), {signal});
      stage.addEventListener('pointermove', event => {
        if (!fine.matches || reduced.matches || this.paused || this.pointerFrame) return;
        this.pointerFrame = requestAnimationFrame(() => {
          this.pointerFrame = 0;
          const box = stage.getBoundingClientRect();
          this.style.setProperty('--tilt-y', (((event.clientX - box.left) / box.width - .5) * 9).toFixed(2) + 'deg');
          this.style.setProperty('--tilt-x', (((event.clientY - box.top) / box.height - .5) * -7).toFixed(2) + 'deg');
        });
      }, {passive:true,signal});
      stage.addEventListener('pointerleave', () => { cancelAnimationFrame(this.pointerFrame); this.pointerFrame = 0; this.style.setProperty('--tilt-x','0deg'); this.style.setProperty('--tilt-y','0deg'); }, {signal});
      this.querySelectorAll('[data-screen]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-screen]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.screen; });
      }, {signal}));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.pointerFrame);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pol-course"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pol-course-offer')) {
  customElements.define('pol-course-offer', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      if (!Number.isFinite(this.deadline)) return;
      this.update();
      if (Date.now() < this.deadline) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!remaining) {
        this.querySelectorAll('[data-course-offer]').forEach(element => { element.hidden = true; });
        this.classList.remove('is-limited-offer');
        this.querySelector('[data-course-price]').textContent = this.dataset.regularPrice;
        const paymentButton = this.closest('.pol-course').querySelector('[data-regular-label]');
        if (paymentButton) paymentButton.querySelector('[data-course-payment-label]').textContent = paymentButton.dataset.regularLabel;
        clearInterval(this.interval);
        return;
      }
      this.querySelector('.pol-course__offer-clock').hidden = false;
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
    }
  });
}
if (!customElements.get('pol-course-browser-surface')) {
  customElements.define('pol-course-browser-surface', class extends HTMLElement {
    connectedCallback() {
      this.course = this.closest('.pol-course');
      if (!this.course) return;
      this.documentRoot = document.documentElement;
      this.previousColor = this.documentRoot.style.getPropertyValue('--pol-course-browser-surface');
      this.previousPriority = this.documentRoot.style.getPropertyPriority('--pol-course-browser-surface');
      this.controller = new AbortController();
      const options = { passive: true, signal: this.controller.signal };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateSurface();
        });
      };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      window.visualViewport?.addEventListener('scroll', this.schedule, options);
      window.visualViewport?.addEventListener('resize', this.schedule, options);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.course);
      this.updateSurface();
    }
    updateSurface() {
      const viewport = window.visualViewport;
      const visibleBottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - 1;
      const sampleY = Math.max(0, Math.min(window.innerHeight - 1, visibleBottom));
      let color = getComputedStyle(this.course).backgroundColor;
      for (const block of this.course.children) {
        if (!block.matches('div, section')) continue;
        const bounds = block.getBoundingClientRect();
        if (bounds.height === 0 || bounds.top > sampleY || bounds.bottom <= sampleY) continue;
        const background = getComputedStyle(block).backgroundColor;
        if (background !== 'transparent' && background !== 'rgba(0, 0, 0, 0)') color = background;
        break;
      }
      if (color === this.color) return;
      this.color = color;
      this.documentRoot.style.setProperty('--pol-course-browser-surface', color);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      if (!this.documentRoot) return;
      if (this.previousColor) {
        this.documentRoot.style.setProperty('--pol-course-browser-surface', this.previousColor, this.previousPriority);
      } else {
        this.documentRoot.style.removeProperty('--pol-course-browser-surface');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
